import { Component } from '@angular/core';
import { MenuService } from '../../../../providers/services/menu.service';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { RouterLinkActive, RouterLink } from '@angular/router';

@Component({
    selector: 'pdp-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    imports: [NgIf, NgFor, RouterLinkActive, RouterLink, AsyncPipe]
})
export class SidebarComponent {

  // public sidebar: Menuitem[] = SIDEBAR_MENU_ITEMS;
  // public sidebarOfficeFurnitureByTipe: Menuitem[] = SIDEBAR_MENU_ITEMS_OFFICE_FURNITURE_BY_TYPE;

  constructor(public menuService :MenuService) {}
}
